import AppLayout from "Layout/Layout";
import { NonIndexRouteObject } from "react-router";
import { getResourcePath } from "./constant";
import { ListPage } from "pages/theo-doi-vi-pham/list-page";
import { DetailPage } from "pages/theo-doi-vi-pham/detail-page";
import { EditPage } from "pages/theo-doi-vi-pham/edit-page";
import { CreatePage } from "pages/theo-doi-vi-pham/create-page";

export const theoDoiViPhamRouters: NonIndexRouteObject[] = [
  {
    path: getResourcePath("theo-doi-vi-pham", "list"),
    element: (
      <AppLayout>
        <ListPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("theo-doi-vi-pham", "detail"),
    element: (
      <AppLayout>
        <DetailPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("theo-doi-vi-pham", "edit"),
    element: (
      <AppLayout>
        <EditPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("theo-doi-vi-pham", "create"),
    element: (
      <AppLayout>
        <CreatePage />
      </AppLayout>
    ),
  },
];
